import React from 'react';
import * as constants from '../../constants';
import * as ListHelpers from './ListHelpers';
import { Table } from '../table/Table';
import { TableFilterBlock } from '../table/TableFilterBlock';
import { getArrayIds, encodeHTMLEntities } from '../helpers/HelperFunctions';
import { TableColumnType } from '../table/Table'
import i18next from "../../i18n";

const ReorderColumnName = "Reorder";
const NumerationColumnName = "NumerationIndex";

const ReorderColumnSettings = {
    "id": "reorder",
    "name": ReorderColumnName,
    "headerName": i18next.t("reorderColumnHeader"),
    "type": TableColumnType.Reorder
}

const NumerationColumnSettings = {
    "id": "numerationIndex",
    "name": NumerationColumnName,
    "headerName": i18next.t("numerationColumnHeader"),
    "type": TableColumnType.String
}

export function actionHandlerCallback(actionType, ids = []) {
    const { actionHandlerCallback } = this.props;
    const { content } = this.state;
    let rows = content.rows.filter(row => ids.indexOf(row.columns['Id']) !== -1);
    let emails = rows.map((item) => item.columns.Email);
    if (actionType === constants.actionTypes.export && this.actionHandlerCallbackDefault)
        this.actionHandlerCallbackDefault(actionType, ids);
    else if (actionHandlerCallback) actionHandlerCallback(actionType, ids, emails);
}
export async function loadData() {
    const filterValues = Object.assign([], this.props.additionalFilter);
    filterValues.State = [constants.alfrescoUserSates.Active];
    await ListHelpers.loadListData.bind(this)(`Table/Get?searchTableTypes=${constants.searchTableTypes.Users}&withAction=${false}`, 1, 2147483646, '', false, filterValues);
}

export function renderContent() {
    const { actionsForAll, companyName, orderBySettings } = this.props;
    const { content } = this.state;
    if (content?.allColumns) {
        const stateCol = content.allColumns.find((item) => item.name === "State");
        if (stateCol)
            stateCol.canFilter = false;
    }

    let contentRows = content?.rows ?? [];
    contentRows.sort((a, b) => {
        if (!a.columns || !b.columns || !a.columns[orderBySettings.fieldName] || !b.columns[orderBySettings.fieldName])
            return 0;
        const aValue = a.columns[orderBySettings.fieldName];
        const bValue = b.columns[orderBySettings.fieldName];
        return orderBySettings.orderedValues.indexOf(aValue) - orderBySettings.orderedValues.indexOf(bValue);
    });
    if (contentRows.length > 0) {
        contentRows.forEach((row, index) => {
            if (companyName)
                row.columns.CompanyName = encodeHTMLEntities(companyName);
            const firstRow = index === 0;
            const lastRow = index === contentRows.length - 1;
            row.columns[ReorderColumnName] = {
                firstRow: firstRow,
                lastRow: lastRow,
                reorderUpHandler: firstRow ? undefined : () => {
                    const orderedValues = this.props.orderBySettings.orderedValues;
                    orderedValues[index] = orderedValues.splice(index - 1, 1, orderedValues[index])[0];
                    if (this.props.orderChangedHandler) {
                        this.props.orderChangedHandler(orderedValues);
                    }
                    else {
                        console.log('WARN: orderChangedHandler prop not set');
                        this.forceUpdate();
                    }
                },
                reorderDownHandler: lastRow ? undefined : () => {
                    const orderedValues = this.props.orderBySettings.orderedValues;
                    orderedValues[index] = orderedValues.splice(index + 1, 1, orderedValues[index])[0];
                    if (this.props.orderChangedHandler) {
                        this.props.orderChangedHandler(orderedValues);
                    }
                    else {
                        console.log('WARN: orderChangedHandler prop not set');
                        this.forceUpdate();
                    }
                }
            };
            row.columns[NumerationColumnName] = index + 1;
        });
    }
    if (content && content.columns) {
        content.columns = content.columns.map(col => {
            col.canFilter = false;
            col.canSort = false;
            col.showFilterInColumn = false;
            return col;
        });
        if (!content.columns.some(col => col.name === NumerationColumnName))
            content.columns.splice(1, 0, NumerationColumnSettings);
        if (!content.columns.some(col => col.name === ReorderColumnName))
            content.columns.push(ReorderColumnSettings);
    }

    return (
        <div className="ordered-list-tb">
            <TableFilterBlock hideFilter={true} exportFileName="users" onSearch={this.onSearch} onSearchClear={this.onSearchClear} onColumnsUpdateHandler={this.onColumnsUpdateHandler} columnsSettings={{ columns: (content && content.allColumns) ? content.allColumns : [], selected: (content && content.columns) ? getArrayIds(content.columns) : [] }} getItems={this.getItemsForExport} />
            {content && content.columns &&
                <Table onColumnFilter={this.onColumnFilter} allowDoubleClickAction={true} allCount={content.allCount} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} actionsForAll={actionsForAll ? actionsForAll : content.actionsForAll} columns={content.columns} items={contentRows} />
            }
        </div>
    );
}